


















































import {Component, Prop, Vue} from "vue-property-decorator";
import RenderProductPrice from "@/components/Shared/RenderProductPrice.vue";
import RenderProductStatus from "@/components/Shared/RenderProductStatus.vue";
import WishlistItem from "@/api/WishlistItem";
import WishlistService from "@/service/WishlistService";

@Component({
  components: {RenderProductStatus, RenderProductPrice}
})
export default class WishlistProductView extends Vue {
  @Prop() private wishlistItem!: WishlistItem;

  isAvailable(): boolean {
    if (this.wishlistItem.product) {
      return this.wishlistItem.product.stockStatus == 1;
    }
    return false;
  }

  async deletewishlistItem(wishlistItemId: number) {
    if (confirm("آیا اطمینان دارید که می‌خواهید این آیتم را حذف کنید؟")) {
      const response = await WishlistService.deleteWishlistItem(wishlistItemId);
      if (response.success) {
        this.$emit('wishlist-item-deleted');
      } else {
        alert("آیتم حذف نشد: " + response.message);
      }
    }
  }
}
